import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect } from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: {},
      inputs: {},
      bases_list: [],
      date_str: '',
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.confirmAdd = this.confirmAdd.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChangeData (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeBase(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.inputs).map(function(k) {
      if(self.state.inputs[k].id === name) {
        change = {
          value: event.target.value,
          value_input: event.target.value,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
        
      } else {
        change = {
          value: self.state.inputs[k].value,
          value_input: self.state.inputs[k].value_input,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
      }
      data_temp.push(change);
    });
    this.setState({inputs: data_temp});
  }
  handleSelectChange(name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.inputs).map(function(k) {
      if(self.state.inputs[k].id === name) {
        change = {
          value: event.label,
          value_input: event.value,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
        
      } else {
        change = {
          value: self.state.inputs[k].value,
          value_input: self.state.inputs[k].value_input,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
      }
      data_temp.push(change);
    });
    this.setState({inputs: data_temp});
  }
  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga/administrativo/'+event.value, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var change = {};
            var data_temp = [];
            Object.keys(responseJson.data.params).map(function(k) {
              var change = {
                value: null,
                value_input: null,
                id: responseJson.data.params[k].id,
                name: responseJson.data.params[k].name,
                type_str: responseJson.data.params[k].type_str,
                type: responseJson.data.params[k].type,
                fatigue_options: responseJson.data.params[k].fatigue_options,
                operator: responseJson.data.params[k].operator,
                hour_points: responseJson.data.params[k].hour_points,
                quantity_points: responseJson.data.params[k].quantity_points,
                point_limit: responseJson.data.params[k].point_limit,
                required: responseJson.data.params[k].required,
                max_points: responseJson.data.params[k].max_points,
                min_points: responseJson.data.params[k].min_points,
                aps_day: responseJson.data.params[k].aps_day,
                hours_day: responseJson.data.params[k].hours_day,
                nocturnal_extra_points: responseJson.data.params[k].nocturnal_extra_points,
                reduction_points: responseJson.data.params[k].reduction_points,
                extra_hours: responseJson.data.params[k].extra_hours,
                automation_type: responseJson.data.params[k].automation_type,
                limit_extra_hours_week: responseJson.data.params[k].limit_extra_hours_week,
                limit_extra_hours_month: responseJson.data.params[k].limit_extra_hours_month,
                day_limit_extra_hours_week: responseJson.data.params[k].day_limit_extra_hours_week,
                day_limit_extra_hours_month: responseJson.data.params[k].day_limit_extra_hours_month,
                automation_type_id: responseJson.data.params[k].automation_type_id,
                automation_field: responseJson.data.params[k].automation_field,
                automation_type: responseJson.data.params[k].automation_type,
                automation_type_name: responseJson.data.params[k].automation_type_name,
                api_type: responseJson.data.params[k].api_type,
              };
              data_temp.push(change);
            });
            self.setState({data: responseJson.data.params, inputs: data_temp, staffs_list: responseJson.data.staffs_list, bases_list: responseJson.data.bases_list});
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }); /* Overlay */
      });
    }
    this.setState(change);
  }
  handleSelectChangeNormal(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  // Setamos o state.date_start para a data de hoje
  componentWillMount () {
      var date_str = new Date().toISOString().slice(0,10).split('-').reverse().join('/');
      this.setState({date_str: date_str});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({applicabilities_list: responseJson.data.applicabilities_list});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  loadInputsData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga/administrativo/', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var change = {};
          var data_temp = [];
          Object.keys(responseJson.data.params).map(function(k) {
            var change = {
              value: null,
              value_input: null,
              id: responseJson.data.params[k].id,
              name: responseJson.data.params[k].name,
              type_str: responseJson.data.params[k].type_str,
              type: responseJson.data.params[k].type,
              fatigue_options: responseJson.data.params[k].fatigue_options,
              operator: responseJson.data.params[k].operator,
              hour_points: responseJson.data.params[k].hour_points,
              quantity_points: responseJson.data.params[k].quantity_points,
              point_limit: responseJson.data.params[k].point_limit,
              required: responseJson.data.params[k].required,
              max_points: responseJson.data.params[k].max_points,
              min_points: responseJson.data.params[k].min_points,
              aps_day: responseJson.data.params[k].aps_day,
              hours_day: responseJson.data.params[k].hours_day,
              nocturnal_extra_points: responseJson.data.params[k].nocturnal_extra_points,
              reduction_points: responseJson.data.params[k].reduction_points,
              extra_hours: responseJson.data.params[k].extra_hours,
              automation_type: responseJson.data.params[k].automation_type,
              limit_extra_hours_week: responseJson.data.params[k].limit_extra_hours_week,
              limit_extra_hours_month: responseJson.data.params[k].limit_extra_hours_month,
              day_limit_extra_hours_week: responseJson.data.params[k].day_limit_extra_hours_week,
              day_limit_extra_hours_month: responseJson.data.params[k].day_limit_extra_hours_month,
            };
            data_temp.push(change);
          });
          self.setState({data: responseJson.data.params, inputs: data_temp});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  confirmAdd(event) {
    event.preventDefault();
    var self = this;
    var confirmed = 0;
    Object.keys(self.state.inputs).map(function(k) {
      if (self.state.inputs[k].value !== null && typeof self.state.inputs[k].value !== 'undefined') {
        var value = self.state.inputs[k].value;
        if (self.state.inputs[k].type == 'hour') {
          var arr = value.split(':');
          value = parseFloat(parseInt(arr[0], 10) + '.' + parseInt((arr[1]/6)*10, 10));
          value = value * self.state.inputs[k].hour_points;
        } else if(self.state.inputs[k].type == 'quantity') {
          value = value * self.state.inputs[k].quantity_points;
        }
        
        if (self.state.inputs[k].max_points !== null) {
          if (value > self.state.inputs[k].max_points) {
            var confirm = window.confirm(self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMaximaFoiUltrapassada(self.state.inputs[k].name));
            if (confirm) {
              if (confirmed !== null) {
                confirmed++;
              }
            } else {
              confirmed = null;
            }
          }
        }
        if (self.state.inputs[k].min_points !== null) {
          if (value < self.state.inputs[k].min_points) {
            var confirm = window.confirm(self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMinimaNaoFoiAtingida(self.state.inputs[k].name));
            if (confirm) {
              if (confirmed !== null) {
                confirmed++;
              }
            } else {
              confirmed = null;
            }
          }
        }
      }
    });
    if (confirmed >= 0 && confirmed !== null ) {
      this.add();
    }
  }

  add() {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var email = localStorage.getItem("data");
    var cid = localStorage.getItem("cid");
    var storage = JSON.parse(cid);
    var datasave = {
      inputs: this.state.inputs,
      date_str: this.state.date_str,
      base_id: this.state.base_id,
      staff_id: this.state.staff_id,
      applicability_id: this.state.applicability_id,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/administrativo/relatorio-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          var url = '/relatorio-de-fadiga/tripulante/administrativo/editar/' + responseJson.data.id + '/' + responseJson.applicability_id + '/' + responseJson.staff_id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          document.location = url;
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
    
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.titulo}</h3>
      <Link to="/relatorios-de-fadiga/tripulante" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.confirmAdd}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          {this.state.applicability_id === 1 ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Tripulantes135}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChangeNormal.bind(this, 'staff_id')}
                  options={this.state.staffs_list}
                />
              </div>
            </div>
            : this.state.applicability_id === 4 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Tripulantes121}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChangeNormal.bind(this, 'staff_id')}
                  options={this.state.staffs_list}
                />
              </div>
            </div>
            : this.state.applicability_id === 2 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Mecanicos}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarMecanico}
                  onChange={this.handleSelectChangeNormal.bind(this, 'staff_id')}
                  options={this.state.staffs_list}
                />
              </div>
            </div>
            : this.state.applicability_id === 3 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Coordenadores}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarCoordenador}
                  onChange={this.handleSelectChangeNormal.bind(this, 'staff_id')}
                  options={this.state.staffs_list}
                />
              </div>
            </div>
            :
            ''
          }
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Data}:</label>
              <InputMask value={this.state.date_str} required maskChar={null} name="date_str" mask="99/99/9999" className="form-control" onChange={this.handleChangeData.bind(this, 'date_str')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Bases}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChangeBase.bind(this, 'base_id')}
                options={this.state.bases_list}
              />
            </div>
          </div>
        </div>
        {Object.keys(self.state.inputs).map(function(k) {
          return (
            <div className="form-group">
              <label>{self.state.inputs[k].name + " - " + self.state.inputs[k].type_str}</label>
              {(self.state.inputs[k].type === 'options') ? 
                <Select
                  className="form-field-name"
                  name="type"
                  required={self.state.inputs[k].required}
                  value={self.state.inputs[k].value_input}
                  searchable={true}
                  placeholder={self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarOpcao}
                  onChange={self.handleSelectChange.bind(self, self.state.inputs[k].id)}
                  options={self.state.inputs[k]['fatigue_options']}
                />
                : (self.state.inputs[k].type === 'hour') ?
                <InputMask required={self.state.inputs[k].required} value={self.state.inputs[k].value} maskChar={null} name={"fatigue_reason_" + self.state.inputs[k].id} mask="99:99" className="form-control" onChange={self.handleChange.bind(self, self.state.inputs[k].id)} placeholder={self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.Horas} />
                :
                <input required={self.state.inputs[k].required} type="text" name={"fatigue_reason_" + self.state.inputs[k].id} className={"form-control"} placeholder={self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.Quantidade} value={self.state.inputs[k].value} onChange={self.handleChange.bind(self, self.state.inputs[k].id)} />
              }
            </div>
          );
        })}
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.botaoAdicionarRelatorioDeFadiga}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportAdd;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportAdmAdd.js